// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__SxNtw","spin":"styles_spin__5UdUK"};